var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createLocalNucleusForm, createReduxNucleusForm, nucleusFormShape } from '../NucleusForm';
import React from 'react';
import PropTypes from 'prop-types';
import storeShape from '../utils/storeShape';
import { omit } from 'lodash';
/**
 * Creates a form component tied to a specific form. The form acts as a
 * provider for children to interact with the form via the nucleusForm context.
 * Any wrapped inputs will be tied to the form.
 * To submit the form use the withForm HOC compoenent around a component to inject
 * the submitForm action for use.
 * @param formId - The id of the form.
 * @param formSelector - An optional selector into the larger redux state where
 *        the form exists. If not provided the nucleus form will be created
 *        with a local form.
 */
export var createForm = function (formId, formSelector) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Form, _super);
            function Form(props, context) {
                var _this = _super.call(this, props, context) || this;
                var store = props.store || context.store;
                if (formSelector && !store) {
                    throw new Error('Could not find "store" in either the context or props of ' + '"Form". Either wrap the root component in a <Provider>, ' + 'or explicitly pass "store" as a prop to "Form".');
                }
                _this.nucleusForm = props.nucleusForm || (formSelector ? createReduxNucleusForm(formId, store, formSelector) : createLocalNucleusForm(formId));
                return _this;
            }
            Form.prototype.getChildContext = function () {
                return {
                    nucleusForm: this.nucleusForm
                };
            };
            Form.prototype.render = function () {
                return React.createElement("div", __assign({}, omit(this.props, ['nucleusForm'])), this.props.children);
            };
            return Form;
        }(React.Component)),
        _a.displayName = 'Form',
        _a.contextTypes = {
            store: storeShape
        },
        _a.childContextTypes = {
            nucleusForm: nucleusFormShape
        },
        _a.propTypes = {
            children: PropTypes.any,
            store: storeShape,
            // Object to use instead of creating own instance of NucleusForm. Intended for testing only.
            nucleusForm: PropTypes.object
        },
        _a;
};
var LocalForm = createForm('LocalForm');
export default LocalForm;
